var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import NoticeContainer from './MessageContainer';
import Message from './Message';
import { defaultProps } from './defaults';
import React from 'react';
import Loading from '../Loading';
import { contentCls } from './messageClass';
import { InfoFilled, SuccessFilled, WarnFilled, WrongFilled } from '@feb-team/legao-icons-react';
import { SpanTag } from '../../Utils/AtomicTag';
var instance;
var noticeType = ['success', 'error', 'info', 'warn', 'loading'];
var message = {
    id: 0,
    config: function (options) {
        if (typeof options.duration === 'number') {
            Object.assign(defaultProps, { duration: options.duration });
        }
        if (options.top) {
            Object.assign(defaultProps, { top: options.top });
        }
        if (options.getContainer) {
            Object.assign(defaultProps, { getContainer: options.getContainer });
        }
    },
    open: function (config) {
        var messageprops = __assign(__assign({}, defaultProps), config), key = message.id++;
        if (!config.content) {
            throw new Error('content defined error');
        }
        else {
            key = config.key || key;
        }
        if (!instance) {
            var props = { className: 'legao-message-container' };
            if (messageprops.getContainer) {
                Object.assign(props, { getContainer: messageprops.getContainer });
            }
            NoticeContainer.newInstance(props, function (obj) {
                instance = obj;
            });
        }
        var typeIcon = {
            info: (React.createElement(SpanTag, { atomics: ['mr-px-8', 'text-brand-600'], className: "legao-notice-icon" },
                React.createElement(InfoFilled, null))),
            success: (React.createElement(SpanTag, { atomics: ['mr-px-8', 'text-succ-900'], className: "legao-notice-icon" },
                React.createElement(SuccessFilled, null))),
            warn: (React.createElement(SpanTag, { atomics: ['mr-px-8', 'text-warn-900'], className: "legao-notice-icon" },
                React.createElement(WarnFilled, null))),
            error: (React.createElement(SpanTag, { atomics: ['mr-px-8', 'text-error-900'], className: "legao-notice-icon" },
                React.createElement(WrongFilled, null))),
            loading: (React.createElement(SpanTag, { atomics: ['mr-px-8'], className: "legao-notice-icon" },
                React.createElement(Loading, null))),
        };
        var Icon = null;
        if (config.icon) {
            Icon = (React.createElement(SpanTag, { atomics: ['mr-px-8'], className: "legao-notice-icon" }, config.icon));
        }
        else if (typeIcon[config.type]) {
            Icon = typeIcon[config.type];
        }
        var noticeInstance = null;
        var noticePromise = new Promise(function (resolve, reject) {
            var className = messageprops.className, onClose = messageprops.onClose, rest = __rest(messageprops, ["className", "onClose"]);
            var message = (React.createElement(Message, __assign({}, rest, { prefixCls: "message", textAlign: "text-center", className: "legao-message__content " + className + " " + (rest.closeable ? 'pr-px-40' : 'pr-px-18'), atomics: contentCls, startAnimation: "legao-message__content--in", closeAnimation: "legao-message__content--out", ref: function (instance) {
                    noticeInstance = instance;
                }, noticeKey: key, onClose: function (key) {
                    onClose === null || onClose === void 0 ? void 0 : onClose(key);
                    resolve(key);
                    instance.removeNotice(key);
                } }),
                Icon, messageprops === null || messageprops === void 0 ? void 0 :
                messageprops.content));
            var mesagecontent = { key: key, content: message };
            instance.notice(mesagecontent);
        });
        var result = function () {
            if (noticeInstance) {
                noticeInstance.close();
            }
        };
        result.then = function (filled, rejected) { return noticePromise.then(filled, rejected); };
        return result;
    },
    success: setType('success'),
    info: setType('info'),
    error: setType('error'),
    warn: setType('warn'),
    loading: setType('loading'),
};
function setType(type) {
    return function (config, duration, onClose) {
        if (typeof config === 'string') {
            var option = { content: config, type: type };
            if (typeof duration === 'function') {
                Object.assign(option, { onClose: duration });
                return message.open(option);
            }
            else if (typeof duration === 'number') {
                Object.assign(option, { duration: duration });
            }
            if (onClose !== undefined) {
                Object.assign(option, { onClose: onClose });
            }
            return message.open(option);
        }
        else {
            Object.assign(config, { type: type });
            return message.open(config);
        }
    };
}
export { message };
